// extracted by mini-css-extract-plugin
export default {"Extras":"Extras_Extras__0Vb5b","Extras__title":"Extras_Extras__title__U0YsM"};